import {Injectable} from '@angular/core';
import {MatSnackBar} from '@angular/material/snack-bar';
import {Router} from '@angular/router';
import {VersioningService} from 'app/fragment/versioning/versioning.service';
import {AbstractSectionResolver} from 'app/routing/resolvers/abstract-section-resolver';
import {DocumentService} from 'app/services/document.service';
import {SectionService} from 'app/services/section.service';
import {ViewMode} from 'app/view/current-view';
import {CurrentLocation, ViewService} from 'app/view/view.service';

@Injectable({
  providedIn: 'root',
})
export class SectionBackgroundResolverService extends AbstractSectionResolver {
  protected breadcrumb: string = 'background';
  protected routeName: string = 'Background and commentary';
  protected viewMode: ViewMode = ViewMode.BACKGROUND;
  protected location: CurrentLocation = CurrentLocation.BACKGROUND;

  constructor(
    protected documentService: DocumentService,
    protected sectionService: SectionService,
    protected versioningService: VersioningService,
    protected viewService: ViewService,
    protected snackBar: MatSnackBar,
    protected router: Router
  ) {
    super(documentService, sectionService, versioningService, viewService, snackBar, router);
  }
}
